import React, { useEffect, useState } from "react";
import styles from "./InstitutionProfile.module.css";
import { useParams } from "react-router-dom";
import FullProfile from "./FullProfile/FullProfile";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import { API_ENDPOINTS } from "../../api/endpoints";
import apiClient from "../../api/apiClient";
import Banner from "./Banner/Banner";
import { useNavigate } from "react-router-dom";

export default function InstitutionProfile() {
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [userData, setUserData] = useState(false);

  const { id } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    fetchProfileData();
  }, []);
  const fetchProfileData = async () => {
    try {
      setLoading(true);
      const res = await apiClient({
        url: `${API_ENDPOINTS.VIEW_INSTITUTION_PROFILE}/${id}`,
        method: "get",
        withAuth: true,
      });

      const profile = res?.data?.profileData[0];
      setUserData(profile);
    } catch (error) {
      console.error("Profile GET Error:", error);
      setApiError(error);
    }

    setLoading(false);
  };

  return (
    <div className={styles.institutionProfile}>
      <Banner userData={userData} />
      <div className={styles.focusArea}>
        <div className={styles.container}>
          <p> Focus Area :</p>
          <ul>
            <li>Artificial Integlligence</li>
            <li>public Policy</li>
            <li>Sustainable Development</li>
            <li>Data Science</li>
            <li>Climate Change</li>
            <li>Digital Governance</li>
            <li>Innovation</li>
          </ul>
        </div>
      </div>
      <main className={styles.profile}>
        {loading ? (
          <Loader />
        ) : apiError ? (
          <ErrorMsg />
        ) : (
          <FullProfile
            profile={userData}
            rating={5}
          />
        )}
      </main>
    </div>
  );
}
